module.exports = __webpack_public_path__ + "static/media/default.41ba6082.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Projects/default.png
// module id = 1480
// module chunks = 2